<template>
  <div class="home">
    <hero
      question="Magst du"
      question1="Bienen"
      question2="Schmetterlinge"
      question3="bunte Blüten"
      claim="Prima! Mit uns verschenkst du Blumen direkt vom Feld. An dich und andere. "
      solution="Das Besondere: Die Blumen bleiben genau dort, wo sie wachsen – auf dem Blühstreifen. Und mit ihnen die vielen kleinen Bienen, Schmetterlinge, Marienkäfer und anderen possierlichen Tierchen, die die Wilde Pracht genauso gerne mögen wie du! Das macht die Landschaft bunter und dein Geschenk ausgefallen, nachhaltig und sinnvoll."
    />
    <textblockHome
      headline="Verschenke jetzt die Patenschaft für eine Wilde Pracht!"
      column1="Warum verschenkst du eigentlich immer Schnittblumen, wenn es doch so viel abwechslungsreicher und nachhaltiger geht? Sicherlich hast du schon einmal davon gehört, dass die Artenvielfalt von Insekten stark zurückgeht. Immer weniger Wild- und Honigbienen, Marienkäfer und Schmetterlinge finden ein Zuhause und ausreichend Nahrung. Mit jedem Quadratmeter Wilde Pracht, für den du eine Patenschaft übernimmst oder verschenkst, schaffst du blühenden Lebensraum und eine kunterbunte Nahrungsquelle für die kleinen nützlichen Tierchen."
      column2="10 oder 15 Blumen? Von wegen! Bei der Wilden Pracht rechnen wir nicht in kleinen Blumensträußen, sondern in Quadratmetern. Und davon bekommst du genau so viele, wie du möchtest – für eine komplette Blühsaison! Das geht ganz schnell: Fülle einfach direkt unten in drei Schritten unser Formular aus und in wenigen Minuten kannst du dir deine Blühkarte herunterladen, mit der du deine Liebsten überraschst. Und dank unserer digitalen Bienenpost könnt ihr die ganze Blühsaison über gemeinsam verfolgen, wie die Blumen wachsen und blühen."
    />
    <cta
      title="Werde jetzt Pate für die Blühsaison 2025."
      subtitle="Oder verschenke eine Blühpatenschaft."
    />
    <Orderform />
  </div>
</template>

<script type="text/babel">
// @ is an alias to /src
import Hero from "@/components/Hero.vue";
import TextblockHome from "@/components/TextblockHome.vue";
import Cta from "@/components/Cta.vue";
import Orderform from "@/components/Orderform/Orderform.vue";

export default {
  name: "Home",
  components: {
    Hero,
    TextblockHome,
    Cta,
    Orderform
  },
  metaInfo: {
    title: "Magst du Blumen? | Wilde Pracht",
    meta: [
      {
        name: "description",
        content:
          "Mit uns verschenkst du nicht nur einen kleinen Strauß, sondern mehr Blumen, als du tragen kannst. Direkt vom Feld. An dich und andere. Neugierig?"
      },
      { itemprop: "name", content: "Magst du Blumen? | Wilde Pracht" },
      { property: "og:title", content: "Magst du Blumen? | Wilde Pracht" },
      {
        itemprop: "description",
        content:
          "Mit uns verschenkst du nicht nur einen kleinen Strauß, sondern mehr Blumen, als du tragen kannst. Direkt vom Feld. An dich und andere. Neugierig?"
      },
      {
        property: "og:description",
        content:
          "Mit uns verschenkst du nicht nur einen kleinen Strauß, sondern mehr Blumen, als du tragen kannst. Direkt vom Feld. An dich und andere. Neugierig?"
      }
    ]
  }
};
</script>

<style lang="scss"></style>
